import { useState, useEffect, useCallback } from 'react';

export const useBbtFeatures = (initialValues = {}, productData = null) => {
  const [tntFsValues, setTntFsValues] = useState(null);

  const parseTntEventData = (eventData) => {
    const parsedValues = {};
    const output = eventData?.output;

    if (!output) {
      return parsedValues;
    }

    Object.keys(output).forEach((key) => {
      const rawValue = output[key];

      if (rawValue === 'true' || rawValue === true) {
        parsedValues[key] = true;
      } else if (rawValue === 'false' || rawValue === false) {
        parsedValues[key] = false;
      } else {
        parsedValues[key] = rawValue;
      }
    });

    return parsedValues;
  };

  useEffect(() => {
    const handleTntFsChange = (eventData) => {
      const parsedValues = parseTntEventData(eventData);
      if (Object.keys(parsedValues).length > 0) {
        setTntFsValues(parsedValues);
      }
    };

    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined' && LIFE_CYCLE_EVENT_BUS.lifeCycle?.on) {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.on('recsFS.tnt', handleTntFsChange);

      return () => {
        if (LIFE_CYCLE_EVENT_BUS.lifeCycle?.off) {
          LIFE_CYCLE_EVENT_BUS.lifeCycle.off('recsFS.tnt', handleTntFsChange);
        }
      };
    }
  }, []);

  const mergedValues = {};
  Object.keys(initialValues).forEach((fsName) => {
    mergedValues[fsName] = tntFsValues?.[fsName] ?? initialValues[fsName];
  });

  const createBbtErrorCallback = useCallback((fallbackApiName = 'fbt_test') => {
    return (anchorId) => {
      const bundles = productData?.product?.info?.recommendationFlags?.bundles;
      const packages = productData?.product?.info?.recommendationFlags?.packages;
      const shouldCheckHideFBT = tntFsValues?.hideFBT !== undefined 
        ? tntFsValues.hideFBT 
        : initialValues.hideFBT;

      if (shouldCheckHideFBT === true && (!bundles || !packages)) {
        if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
          const fallbackData = {
            apiName: fallbackApiName,
            itemId: anchorId,
            reason: 'error'
          };
          LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('bbt.fallback', fallbackData);
        }
      }
    };
  }, [productData, tntFsValues, initialValues.hideFBT]);

  return {
    ...mergedValues,
    tntFsValues,
    initialValues,
    createBbtErrorCallback
  };
};